import { Observable } from 'rxjs';
import { PlacementConfig } from '../../models/placement-config.model';
import { PlacementMetadata } from '../../models/placement-meta-data.model';
import { GeneratePlacementResponse } from '@ads-ep/fetch-api-client';

export abstract class CommonPlacement{
  actionQuerySelector = '[data-action-type]';
  clickActions$: Observable<MouseEvent>;
  enterKeyActions$: Observable<KeyboardEvent>;
  placementActions$: Observable<UIEvent>;
  placementConfig: PlacementConfig;
  placementMetaData: PlacementMetadata;
  brandPresentmentConfig?: GeneratePlacementResponse;

  /*
  * Parse injected dom for data-action-id attributes.
  * If found, bind a click handler to them to call performPlacementAction
  * */
  abstract bindActions(domTarget: HTMLElement): void;

  fetchQuerySelector(attrValue?: string){
    return attrValue  ? `[data-content-fetch="${attrValue}"]` : '[data-content-fetch]';
  }

  addedToDom(){

  }
}
